module.exports = __webpack_public_path__ + "img/user-nav-jrzcrs-icon.ff3bf1f0.png";